/* eslint-disable @next/next/no-img-element */
import { CommentsComponent } from "@modules/forum/component/comments";
import { IconButton, TextareaAutosize } from "@mui/material";
import { getAssets, htmlParse } from "@unisearch/helpers";
import moment from "moment";
import Link from "next/link";
import React from "react";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import { ReactSVG } from "react-svg";
import styles from "./other_post.module.scss";

const OtherPost = ({
  video,
  featureImage,
  answer,
  profileImage,
  name,
  userType,
  questionTitle,
  question,
  questionLink,
  publishedDate,
  groupSlug,
  commentType,
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.heading_wrapper}>
        <div className={styles.info_wrapper}>
          <div className={styles.image_wrapper}>
            <img
              src={
                profileImage ?? getAssets("/assets/student-avatar-small.png")
              }
              alt={name}
            />
          </div>
          <div className={styles.title_wrapper}>
            <h4 className={styles.title}>{name}</h4>
            <div className={styles.text_wrapper}>
              <div className={styles.label}>{userType}</div>
              {publishedDate && (
                <div className={styles.clock_wrapper}>
                  <ReactSVG src={getAssets("assets/icons/clock.svg")} />
                  {/* <BsClockFill /> */}
                </div>
              )}
              {publishedDate && (
                <span className={styles.timeline}>
                  Due {moment(publishedDate).format("DD MMM")}
                </span>
              )}
            </div>
          </div>
        </div>
        <IconButton>
          <BiDotsHorizontalRounded />
        </IconButton>
      </div>
      <div className={styles.content}>
        {questionTitle && (
          <Link legacyBehavior href={`/forum/${questionLink}`}>
            <a className={styles.question_title}>{questionTitle}</a>
          </Link>
        )}
        <br />
        {answer ?? htmlParse(question)}
        {featureImage && (
          <div className={styles.feature_image_wrapper}>
            <img src={featureImage} alt="Feature Iamge" />
          </div>
        )}
        {video && (
          <div className={styles.feature_video_wrapper}>
            <iframe
              width="560"
              height="315"
              src={`https://www.youtube.com/embed/${video}`}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        )}
      </div>

      <CommentsComponent
        groupSlug={groupSlug}
        postSlug={questionLink}
        commentType={commentType}
      />
    </div>
  );
};

export default OtherPost;
